// DS: i11.2
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const OriginalBrush: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.6424 5.98453C7.85108 6.09698 8.06248 6.22297 8.27312 6.36389C9.10396 6.91973 9.93102 7.71493 10.5294 8.82655L14.3462 4.25579C16.2286 1.72346 13.6236 -0.0469415 11.8569 1.70174L7.6424 5.98453Z" fill="currentColor"/>
      <path d="M9.5852 9.89674C10.6125 13.4112 6.16401 16.7683 1.18833 13.9457C0.923591 13.7955 0.94276 13.3902 1.21562 13.2574C1.79405 12.9759 2.54214 12.318 2.92033 10.7805C3.58172 8.07658 5.57037 6.2934 7.4438 7.25635C8.44631 7.77165 9.16096 8.44544 9.5852 9.89674Z" fill="currentColor"/>
    </svg>
  </IconWrap>
);
OriginalBrush.displayName = 'OriginalBrush';

export default OriginalBrush;
